import { useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';

import { CUSTOMER_FUNDING_ACCOUNTS } from 'queries/fundingAccounts';

const useFundingAccounts = () => {
  const { customerId, accountId } = useParams();

  const fundingAccountsQuery = useQuery(CUSTOMER_FUNDING_ACCOUNTS, {
    variables: { customerId, accountId },
  });

  const fundingAccounts = fundingAccountsQuery.data?.fundingAccounts ?? [];

  const addNewFundingAccount = (newFundingAccount) => {
    if (!newFundingAccount) {
      return null;
    }

    return `${newFundingAccount.bankName} ...${newFundingAccount.numberLast4}`;
  };

  return { fundingAccounts, addNewFundingAccount };
};

export default useFundingAccounts;
